import React from 'react';
import { Box, Typography, Container, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';

const Footer: React.FC = () => {
    const navigate = useNavigate();
    const currentYear = new Date().getFullYear();

    return (
        <Box
            component="footer"
            sx={{
                mt: 'auto',
                bgcolor: '#f5f5f5',
                py: 1.5,
                borderTop: '1px solid #e0e0e0'
            }}
        >
            <Container maxWidth="lg">
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
                    {/* Copyright */}
                    <Typography variant="body2" color="text.secondary">
                        © {currentYear} LAGUNE PLONGEE - Tous droits réservés
                    </Typography>

                    {/* Informations légales */}
                    <Typography variant="body2" color="text.secondary">
                        Quai Arthur RIMBAUD, 66750 SAINT-CYPRIEN - RCS Perpignan B 518 987 383
                    </Typography>

                    {/* Liens légaux */}
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button
                            size="small"
                            onClick={() => navigate('/legal')}
                            sx={{
                                color: 'text.secondary',
                                textTransform: 'none',
                                fontSize: '0.75rem',
                                minWidth: 'auto',
                                px: 1,
                                '&:hover': {
                                    color: 'primary.main'
                                }
                            }}
                        >
                            Mentions légales
                        </Button>
                        <Button
                            size="small"
                            onClick={() => navigate('/contact')}
                            sx={{
                                color: 'text.secondary',
                                textTransform: 'none',
                                fontSize: '0.75rem',
                                minWidth: 'auto',
                                px: 1,
                                '&:hover': {
                                    color: 'primary.main'
                                }
                            }}
                        >
                            Contact
                        </Button>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
